import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, BasicInput, Alert } from '@dev/ee-components';
import { HardDeleteDialogProps } from './types';
import { DeleteConformationWrapper, TextWrapper } from './styled';

export const HardDeleteDialog = ({ text, deleteConfirmationText = '', changeDeleteConfirmationText, isContactFromPaidList }: HardDeleteDialogProps): JSX.Element => {
    const { t } = useTranslation();

    const handleDeleteConfirmationTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (changeDeleteConfirmationText) {
            changeDeleteConfirmationText(e.target.value);
        }
    };

    return (
        <>
            <TextWrapper>
                <Typography variant="body1" bodyVariant="onPaper">
                    {text}
                </Typography>
            </TextWrapper>
            {isContactFromPaidList && (
                <TextWrapper>
                    <Alert
                        body={t('deletecontactspaidlistmsg')}
                        severity="warning"
                    />
                </TextWrapper>
            )}
            <DeleteConformationWrapper>
                <Typography variant="body1" bodyVariant="onPaper">
                    {t('confirmdeleteaction')}
                </Typography>
            </DeleteConformationWrapper>
            <DeleteConformationWrapper>
                <BasicInput 
                    id="input-delete-confirmation"
                    onChange={handleDeleteConfirmationTextChange}
                    defaultValue={deleteConfirmationText}
                />
            </DeleteConformationWrapper>
        </>
    );
};
